import react, { useContext, useEffect, useState, useMemo } from 'react'
import { Box, IconButton, ListItem, Tooltip, Link } from "@mui/material"
import { Edit, OpenInNew } from '@mui/icons-material'
import ChangeField from '../../ChangeField'
import './styles.css'
import { ScreenContext } from '..'
import api from '../../../api'
import { getSession } from '../../../auth'
import { timedFetchEnterprise } from '../../Dialogs/Client'
import dayjs from 'dayjs';

import { useHistory } from "react-router-dom"

const mergeData = (arr1, arr2) => {
    return Object.values(
        Object.fromEntries(
            [...(arr1 || []).flatMap(item => item.id ? [[item.id, item]] : []) , ...(arr2 || []).flatMap(item => item.id ? [[item.id, item]] : [])]))
}

const isUrlField = (field) =>
    typeof field === "string" && (field === "linkedin_url" || field.endsWith("_url"));

const normalizeHttpUrl = (raw) => {
    if (!raw) return null;

    const v = String(raw).trim();
    const withProto = /^https?:\/\//i.test(v) ? v : `https://${v}`;

    try {
        const u = new URL(withProto);
        if (!["http:", "https:"].includes(u.protocol)) return null;
        return u.toString();
    } catch {
        return null;
    }
};

export const GeneralData = ({ icon, name, data, editable, onClick, tooltip, namealias, options, optionEntries, customField, placeholder, reloadParent=()=>{}, date=false, cpf=false }) => {

    const history = useHistory()

    const { enterpriseId, profile, setProfile, getClients } = useContext(ScreenContext)

    const hasclick = onClick ? { sx: { cursor: 'pointer' }, onClick: onClick } : {}

    const [edit, setEdit] = useState(false)
    const [enterprises, setEnterprises ] = useState(null)
    
    const decideName = useMemo(() => {
        if (options)
            return options[data[editable]]
        else if (date)
            return (data[editable]) ? dayjs(data[editable]).format("DD/MM/YYYY") : null
        else if (data.custom_field_type === 'date')
            return (data[editable]) ? dayjs(data[editable]).format("DD/MM/YYYY") : null
        else if (data.custom_field_type === 'boolean')
            return Number(data[editable]) === 1 ? 'Sim' : 'Não'
        else if (namealias)
            return namealias
        else if (editable)
            return data[editable]
        return data
    }, [data, namealias, options, editable])

    useEffect(()=>{
        if (editable && editable === 'contact_enterprise'){
            timedFetchEnterprise((rdata) => setEnterprises(prev => [{
                     "id": NaN,  
                     "name": "Remover empresa",
                 }, ...(mergeData(prev, rdata))]), data.contact_enterprise_name || '')
        }
    }, [editable, data.contact_enterprise_name])

    return (
        <>
            <ListItem className={`contact-general-listitem ${data.custom_field_type === 'textarea' && edit ? 'textarea-edit-mode' : ''}`}>
                <Box className='contact-general-item-box'>
                    {tooltip ? (
                        <Tooltip title={name}>
                            <span>{icon}</span>
                        </Tooltip>
                    ) : (
                        <span className='align-icons'>
                            <Box sx={{ display: 'flex' }}>
                                {icon}
                            </Box>
                            {!edit &&
                                <Box display="flex" gap={.5} alignItems="center">
                                    {name}
                                    {editable === "contact_enterprise" && data?.contact_enterprise &&
                                        <Tooltip title="Ver empresa">
                                            <IconButton
                                                sx={{ padding: "4px" }}
                                                onClick={() => {
                                                    history.push({
                                                        pathname: "/chat",
                                                        search: `selectedTab=enterprises&selectedEnterprise=${data?.contact_enterprise}`,
                                                    })
                                                }}
                                            >
                                                <OpenInNew sx={{ fontSize: "1rem" }} />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </Box>
                            }
                        </span>
                    )}
                </Box>
                {!edit ?
                    <Box className='contact-general-field'>
                        {/* {decideName ? <Box className='contact-general-data' {...hasclick}>{decideName}</Box> :  */}
                        {decideName ? (
                            <Box className='contact-general-data' {...hasclick}>
                                {isUrlField(editable) && typeof decideName === "string" && normalizeHttpUrl(decideName) ? (
                                    <Link
                                        href= { normalizeHttpUrl(decideName) }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        underline="hover"
                                        onClick={(e) => e.stopPropagation()} // evita disparar onClick do Box (ex.: copiar)
                                    >
                                        {decideName}
                                    </Link>
                                ) : (
                                    decideName
                                )}
                            </Box>
                        ) : (
                            <Box className='contact-general-data placeholder' onClick={() => { setEdit(true) }}>
                                {placeholder}
                            </Box>
                        )}
                        {editable &&
                            <IconButton sx={{ fontSize: '.9em', padding: '.1rem' }}>
                                <Edit onClick={() => { setEdit(true) }} />
                            </IconButton>
                        }
                    </Box>
                    :
                    <Box className={data.custom_field_type === 'textarea' ? 'textarea-field-wrapper' : ''}>
                        <ChangeField value={data[editable]}
                            router={`api/enterprises/${enterpriseId}/contacts/${data.profileId || data.id}/`}
                            field={editable}
                            label={name}
                            editmode={() => setEdit(false)}
                            options={customField && data.custom_field.field_type === 'boolean' ? {1: 'Sim', 0: 'Não'} : options}
                            optionEntries={customField && data.custom_field.field_type === 'boolean' ? undefined : optionEntries}
                            customField={customField}
                            data={data}
                            updateField={(newdata) => {
                                let changedata = newdata
                                
                                if (editable && editable === 'contact_enterprise'){
                                    changedata = newdata?.contact_enterprise || null
                                    data.contact_enterprise_name = newdata?.contact_enterprise_name
                                    profile.contact_enterprise_name = newdata?.contact_enterprise_name
                                    // if ('fetchEnterprises' in window)
                                    //     window.fetchEnterprises()
                                }
                                else if (editable && customField){
                                    profile.custom_fields = customField
                                }
                                else if (editable && editable === 'owner'){
                                    profile.owner = data.owner
                                    profile.owner_name = options[changedata]
                                }
                                data[editable] = changedata
                                profile[editable] = changedata
                                setEdit(false)
                                reloadParent()
                                if ('reloadChat' in window)
                                    window.reloadChat()
                            }}
                            reloadContact={(data) => {setProfile(data); setEdit(false); getClients()}}
                            contactEnterprises={enterprises}
                            fetchContactEnterprises={(name) => {
                                timedFetchEnterprise((rdata) => setEnterprises(prev => [{
                                                    "id": NaN,  
                                                    "name": "Remover empresa",
                                                }, ...mergeData(prev, rdata)]), name)
                            }}
                            date={date}
                            cpfField={cpf}
                        />
                    </Box>
                }
            </ListItem>

        </>
    )
}